import { TooltipProvider } from '@kalos/ui';

import { BreakDownBadge } from './BreakDownBage';
import { type DateStatusBreakout } from './utils';

/**
 * Job-type breakout for a column header. Renders the four status pills as a centered,
 * shrink-wrapped block that is a single row of four when the column is wide enough
 * (container >= 11rem) and a 2x2 grid otherwise — never a ragged 3+1 wrap.
 */
export const CallWindowBreakout = ({
  total,
  completed,
  confirmed,
  pending,
}: DateStatusBreakout) => {
  return (
    <TooltipProvider>
      <div className="@container mt-1 w-full">
        <div className="@[11rem]:grid-cols-[repeat(4,auto)] mx-auto grid w-fit grid-cols-[repeat(2,auto)] items-center gap-1 [&>*]:cursor-pointer">
          <BreakDownBadge status="Total" totalCount={total.count} breakdown={total.breakdown} />
          <BreakDownBadge
            status="Completed"
            totalCount={completed.count}
            breakdown={completed.breakdown}
          />
          <BreakDownBadge
            status="Confirmed"
            totalCount={confirmed.count}
            breakdown={confirmed.breakdown}
          />
          <BreakDownBadge
            status="Pending"
            totalCount={pending.count}
            breakdown={pending.breakdown}
          />
        </div>
      </div>
    </TooltipProvider>
  );
};
